<template>
    <b-modal id="modalItems" data-backdrop="static" data-keyboard="false" size="xl" v-model="exibirRotinas" centered>
        <template #modal-header>
            <div class="col-12 d-flex" style="justify-content: space-between">
                <h4>Configuração de tradução!</h4>
                <div class="d-flex">
                    <div v-if="$store.state.painel.loading" class="loading-container mr-4">
                        <div class="spinner"></div>
                    </div>
                    <button class="btn btn-outline-success" @click="traduzir()">Traduzir</button>
                </div>

            </div>
        </template>

        <div class="col-12">
            <div class="row">
                <div class="col-12 d-grid"> 
                    <div class="col-12" >
                        <h6>Portugues:</h6>
                        <input class="form-control" v-model="palavra_frase" type="text" name="" id="">
                    </div>
                </div>
                <hr width="100%">
                <div class="col-12 d-grid">
                    <div class="col-12">
                        <h6>Inglês:</h6>
                        <input class="form-control" v-model="traducao_en" type="text" name="" id="">
                    </div>
                    <div class="col-12 mt-3 ">
                        <h6>Espanhol:</h6>
                        <input class="form-control" v-model="traducao_es" type="text" name="" id="">
                    </div>
                    <div class="col-12 mt-3 ">
                        <h6>Francês:</h6>
                        <input class="form-control" v-model="traducao_fr" type="text" name="" id="">
                    </div>
                    <div class="col-12 mt-3 ">
                        <h6>Holandes:</h6>
                        <input class="form-control" v-model="traducao_ho" type="text" name="" id="">
                    </div>
                    <div class="col-12 mt-3 ">
                        <h6>Alemão:</h6>
                        <input class="form-control" v-model="traducao_ge" type="text" name="" id="">
                    </div>
                </div>
            </div>
        </div>

        <template #modal-footer>
            <div class="w-100">
                <div class="row center" style="justify-content: center; ">
                    <div class="row center" style="justify-content: center; ">
                        <b-button class="mr-2" variant="danger" size="lg" @click="$emit('closeModal')">
                            Fechar
                        </b-button>
                        <b-button size="lg" variant="success" @click="salvarAgendamento">
                            Salvar
                        </b-button>
                    </div>
                </div>
            </div>
        </template>
    </b-modal>
</template>

<script>
/* eslint-disable */

export default {
    data() {
        return {
            exibirRotinas: true,
            palavra_frase: '',
            traducao_en: '',
            traducao_es: '',
            traducao_fr: '',
            traducao_ho: '',
            traducao_ge: '',
            acaoGlobal: ''
        }
    },

    props: {
        palavra: {}
    },

    computed: {

    },

    methods: {
        preencherTraducoes(langSystem) {
            const languageFieldMap = {
                pt: 'palavra_frase',
                en: 'traducao_en',
                es: 'traducao_es',
                fr: 'traducao_fr',
                ho: 'traducao_ho',
                ge: 'traducao_ge'
            }

            langSystem.forEach(item => {
                const field = languageFieldMap[item.language_code]

                if (field && this.hasOwnProperty(field)) {
                    this[field] = item.translate
                }
            })
        },
        async traduzir() {
            const traducoes = await this.$store.dispatch('painel/traduzir', this.palavra_frase.toLocaleLowerCase())

            this.traducao_es = traducoes.es.translations[0].text ?? ''
            this.traducao_en = traducoes.en.translations[0].text ?? ''
            this.traducao_ge = traducoes.de.translations[0].text ?? ''
            this.traducao_fr = traducoes.fr.translations[0].text ?? ''
            this.traducao_ho = traducoes.nl.translations[0].text ?? ''
        },

        salvarAgendamento() {
            const data = {
                acao_global: this.acaoGlobal,
                palavra_frase: this.palavra_frase.toUpperCase(),
                // traducao: this.traducao.toUpperCase(),
                palavra: this.palavra,
                traducao_es: this.traducao_es.toUpperCase(),
                traducao_en: this.traducao_en.toUpperCase(),
                traducao_ge: this.traducao_ge.toUpperCase(),
                traducao_fr: this.traducao_fr.toUpperCase(),
                traducao_ho: this.traducao_ho.toUpperCase(),
            }

            this.$store.dispatch('painel/acaoDicionario', { data: data }).then(response => {
                this.$emit('closeModal')
                this.$store.dispatch('painel/getPalavras')
                this.$swal.fire({
                    title: 'Sucesso!',
                    text: 'Agendamento salvo com sucesso!',
                    icon: 'success',
                    timer: 1000
                })
            }).catch(() => {
                this.$swal.fire({
                    title: 'Oops!',
                    text: 'Palavra já cadastrada!',
                    icon: 'warning',
                    timer: 2500
                })
            })
        },
    },
 
    created() {
        this.$store.dispatch('painel/getRotinas')
        this.$store.dispatch('painel/getEmpresas')
        // console.log(Object.entries(this.palavra).lenght === 0)
        console.log(this.palavra)
        if (this.palavra == '') {
            this.acaoGlobal = 'salvar'
        } else {
            console.log(this.palavra)
            this.palavra_frase = this.palavra.name
            this.acaoGlobal = 'editar'

            this.preencherTraducoes(this.palavra.lang_system)
        }
    }
}
</script>
<style >
.loading-container {
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: Arial, sans-serif;
  font-size: 14px;
  color: #555;
}

.spinner {
  width: 22px;
  height: 22px;
  border: 3px solid #ddd;
  border-top: 3px solid #28a745; /* verde bootstrap */
  border-radius: 50%;
  animation: spin 0.9s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

</style>